import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator function that checks if the control's value contains any disallowed delimiters.
 *
 * @param {RegExp} [delims=/[;,]/u] - A regular expression defining the delimiters to disallow. Defaults to comma and semicolon.
 * @return {ValidatorFn} A function that takes an AbstractControl and returns a ValidationErrors object
 *                       if the value contains disallowed delimiters, or null if valid.
 */
export function disallowDelimiters(delims: RegExp = /[;,]/u): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const raw = control.value ?? '';
    if (typeof raw !== 'string') {
      return null;
    }

    // normalize
    const value = raw.trim().replace(/\s+/g, ' ');
    if (!value) {
      return null;
    }

    return delims.test(value) ? { multiEntryDelimiter: true } : null;
  };
}
